import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import * as commondata from "../../Common";
import useHideShowDropDown from "../../helpers/hideshowdropdown";

const AutoCompleteRelateER = ({
  getReletedTattleId,
  clearautocomplete,
  clearTattleIdHandler,
  isExternal = false,
  extraQuery = '',
  placeholder = "Search ID or Title",
}) => {
  const params = useParams();
  const autosearh = useRef(null);
  const [state, setState] = useState({
    search: "",
    selectedItem: "",
    data: [],
    loading: false,
    isShowPopup: true,
  });
  const hideDropdown = () => {
    setState((state) => {
      return {
        ...state,
        isShowPopup: false,
      };
    });
  };

  useHideShowDropDown(autosearh, () => {
    hideDropdown();
  });

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        loading: true,
        data: [],
      };
    });
    let timeid = setTimeout(async () => {
      if (state.search) {
        const fetchresponse = await fetch(
          `${commondata.getCommonData().apiUrl}tattle/rows/?app_token=${
            commondata.getCommonData().app_token
          }${!isExternal ? `&attribute_set_key=${params.attribute_set_key}` : ""}&search=${
            state.search
          }${extraQuery? `&${extraQuery}` : ''}`,
        );

        const rdata = await fetchresponse.json();
        if (rdata.code === 200) {
          setState((state) => {
            return {
              ...state,
              data: rdata.data || [],
              loading: false,
            };
          });
        }
      }
    }, 500);

    return () => {
      clearInterval(timeid);
    };
  }, [state.search]);
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        search: "",
      };
    });
  }, [clearautocomplete]);

  const searchHanler = (evt) => {
    if (!evt.target.value) {
      clearTattleIdHandler();
    }
    setState((state) => {
      return {
        ...state,
        search: evt.target.value,
        isShowPopup: true,
      };
    });
  };

  const selectItemHandler = (item) => {
    getReletedTattleId(item.customer_tattle_uuid);
    setState((state) => {
      return {
        ...state,
        selectedItem: item.customer_tattle_uuid,
        search: `${item.customer_tattle_uuid} - ${item.title.slice(0, 30)}`,
        isShowPopup: false,
      };
    });
  };

  return (
    <div className="my-auto-search" ref={autosearh}>
      <input
        type="text"
        className="iputSearch"
        onChange={searchHanler}
        value={state.search}
        placeholder={placeholder}
      />
      {state.search && state.isShowPopup && (
        <div className="auto-search">
          <ul>
            {state.loading ? (
              <li>Loading...</li>
            ) : (
              state.data.length === 0 && <li>No record found</li>
            )}
            {state.data?.length > 0 &&
              state.data.map((item, key) => (
                <li key={key} onClick={() => selectItemHandler(item)}>{`${
                  item.customer_tattle_uuid
                } - ${item.title}`}</li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AutoCompleteRelateER;
